import repository from "@/api/Main/reminders";

export default {
  state: {
    reminders: [],
    reminders_loading: false,
    reminder_dialog: { open: false, editId: null },
  },

  getters: {
    GET_REMINDERS: (state) => state.reminders,
    GET_UPCOMING_REMINDERS: (state) => state.reminders.filter((r) => !r.fired_at),
    GET_RECURRING_REMINDERS: (state) => state.reminders.filter((r) => r.is_recurring),
    REMINDERS_LOADING: (state) => state.reminders_loading,
    REMINDER_DIALOG: (state) => state.reminder_dialog,
  },

  mutations: {
    SET_REMINDERS(state, data) {
      state.reminders = data;
    },
    ADD_REMINDER(state, reminder) {
      state.reminders.unshift(reminder);
    },
    UPDATE_REMINDER(state, updated) {
      const idx = state.reminders.findIndex((r) => r.id === updated.id);
      if (idx !== -1) state.reminders.splice(idx, 1, updated);
    },
    REMOVE_REMINDER(state, id) {
      state.reminders = state.reminders.filter((r) => r.id !== id);
    },
    SET_REMINDERS_LOADING(state, val) {
      state.reminders_loading = val;
    },
    OPEN_REMINDER_DIALOG(state, editId = null) {
      state.reminder_dialog = { open: true, editId };
    },
    CLOSE_REMINDER_DIALOG(state) {
      state.reminder_dialog = { open: false, editId: null };
    },
  },

  actions: {
    async fetchReminders({ commit }, params = {}) {
      commit("SET_REMINDERS_LOADING", true);
      try {
        const res = await repository.index(params);
        commit("SET_REMINDERS", res.data.data);
      } finally {
        commit("SET_REMINDERS_LOADING", false);
      }
    },

    async createReminder({ commit }, payload) {
      const res = await repository.store(payload);
      commit("ADD_REMINDER", res.data.data);
      return res.data;
    },

    async updateReminder({ commit }, { id, payload }) {
      const res = await repository.update(id, payload);
      commit("UPDATE_REMINDER", res.data.data);
      return res.data;
    },

    async deleteReminder({ commit }, id) {
      await repository.destroy(id);
      commit("REMOVE_REMINDER", id);
    },

    async snoozeReminder({ dispatch }, { id, duration }) {
      const res = await repository.snooze(id, duration);
      await dispatch("fetchNotifications");
      return res.data;
    },
  },
};
